import React from 'react'
import Header from '../header/HeaderFour';
import Breadcrumb from '../inner/Breadcrumb';
import About from '../elements/AboutThree';
import WorkingProcess from '../elements/WorkingProcess';
import Service from "../elements/ServiceOne";
import Counter from "../elements/Counter";
import Footer from '../elements/Footer';

function about() {
    return(

        <div className="about-us">

            <Header/>
        <main>
            <Breadcrumb title="About Us" sub_title="Home" active="About"/>
            <About/>
            <WorkingProcess/>
            <Service/>
            <Counter/>
            <Footer/>
        </main>


        </div>
        
    )
}

export default about